import { formatCurrency } from '@if/core/utils'
import { Typography } from '@mui/material'
import { LoanSummaryInformationResultDto } from '@src/api/loan/loan-dto'
import { useTranslation } from 'react-i18next'

interface Props {
  summaryInformation: LoanSummaryInformationResultDto
}

const LoanLastTransactionCardContent = ({ summaryInformation }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      {summaryInformation === undefined && (
        <Typography variant="caption" component="p" gutterBottom>
          {t('loan.payment.lastTransactionCard.empty')}
        </Typography>
      )}
      <Typography variant="caption">
        {t('loan.payment.lastTransactionCard.totalPrincipal')}
      </Typography>
      <Typography gutterBottom sx={{ ml: 2 }}>
        {formatCurrency(summaryInformation?.totalPrincipalPaid ?? 0)}
      </Typography>
      <Typography variant="caption">
        {t('loan.payment.lastTransactionCard.totalInterest')}
      </Typography>
      <Typography gutterBottom sx={{ ml: 2 }}>
        {formatCurrency(summaryInformation?.totalInterestPaid ?? 0)}
      </Typography>

      <Typography variant="caption">
        {t('loan.payment.lastTransactionCard.totalFees')}
      </Typography>
      <Typography gutterBottom sx={{ ml: 2 }}>
        {formatCurrency((summaryInformation?.totalAdminFeesPaid ?? 0) + (summaryInformation?.totalNsfFeesPaid ?? 0))}
      </Typography>

      <Typography variant="caption">
        {t('loan.payment.lastTransactionCard.totalPaid')}
      </Typography>
      <Typography gutterBottom sx={{ ml: 2 }}>
        {formatCurrency(
          (summaryInformation?.totalPrincipalPaid ?? 0)
          + (summaryInformation?.totalInterestPaid ?? 0)
          + (summaryInformation?.totalAdminFeesPaid ?? 0)
          + (summaryInformation?.totalNsfFeesPaid ?? 0)
        )}
      </Typography>
    </>
  )
}

export default LoanLastTransactionCardContent
